import React from 'react';
import _ from 'lodash';
import R from 'ramda';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';

import {
  Input,
  Icon,
  Divider,
  Message,
} from 'semantic-ui-react';

import {
  YOUTUBE,
  FACEBOOK,
  TWITTER,
  INSTAGRAM,
} from '../../utils/static-configuration';

import ThemeSelector from '../../themes/theme-selector';
import TargetLink from '../../components/target-link';

const inputStyle = {
  marginTop: 10,
  marginBottom: 10,
};

const scanningProgressDivStyle = {
  height: 249,
  width: '100%',
  textAlign: 'center',
  paddingTop: 40,
};

const NUMBER_OF_INPUTS = 1;

const isEmptyHashtag = arg => _.isEmpty(arg) || _.size(_.trim(arg)) < 5;

const getChannelIconColour = channel => {
  const colours = {
    YOUTUBE: 'red',
    FACEBOOK: 'blue',
    INSTAGRAM: 'pink',
    TWITTER: 'blue',
  };
  return _.get(colours, channel, 'gray');
};

const HashtagScannerModal = ({
  isScanning,
  currentScannedPlatform,
  scannerResultsCount,
  hashtags,
  hashtagsErrors,
  onInputValueChange,
  onClose,
  onScanHandler,
  isEmptyState,
}) => {
  const withErrors = _.find(hashtagsErrors, ['isError', true]);
  const hashtagValues = _.map(hashtags, 'value');
  const noHashTags = R.allPass([isEmptyHashtag])(hashtagValues);
  const { disableHelpLinks } = ThemeSelector.theme();
  return (
    <DyzioModal
      headerText="Hashtag Scanner"
      size="tiny"
      hasActionButton
      actionButtonContent="Scan"
      actionButtonIcon={<Icon name="search" />}
      shouldDisableActionButton={isScanning || noHashTags}
      onActionButtonClick={onScanHandler}
      onClose={onClose}
      hasFeedbackProvider={withErrors}
      feedbackContent="Numbers are allowed in hashtags. However, spaces and special characters, like $ or %, won’t work"
      feedbackType="error"
    >

      {
        isEmptyState &&
        <div>
          <Message
            icon="info circle"
            info
            header="Add some influencers"
            content="Make sure you&apos;ve added some influencers before running the hashtag scanner."
          />
        </div>
      }

      {
        !isEmptyState && isScanning &&
        <div style={scanningProgressDivStyle}>
          <Icon
            name={currentScannedPlatform ? _.lowerCase(currentScannedPlatform) : 'search'}
            size="massive"
            color={getChannelIconColour(currentScannedPlatform)}
          />
          <Divider hidden />
          {
            currentScannedPlatform &&
            <span>
              Scanned {currentScannedPlatform}.
              Found {scannerResultsCount} posts.
            </span>
          }
          {
            !currentScannedPlatform && <span>Scanning...</span>
          }
        </div>
      }
      {
        !isEmptyState && !isScanning &&
        <div>
          <p>
            Enter tags below, exactly as you want them to be searched i.e. &quot;#specialoffer&quot; or &quot;acme&quot; or &quot;@nike&quot;
          </p>

          {
            _.map(_.range(NUMBER_OF_INPUTS), position => {
              const hashtag = _.find(hashtags, ['name', `hashtag_${position}`]);
              const hashtagErrorState = _.find(hashtagsErrors, ['position', position]);
              return (
                <Input
                  fluid
                  style={inputStyle}
                  error={hashtagErrorState && hashtagErrorState.isError}
                  placeholder={'enter hashtag here (minimum of 4 letters)'}
                  name={`hashtag_${position}`}
                  onChange={onInputValueChange}
                  value={hashtag ? hashtag.value : null}
                />
              );
            })
          }

          <p>
            You can search hashtags, @mentions or any text.
          </p>
          {!disableHelpLinks && (<p>
            <TargetLink
              renderIf
              href="http://help.dyzio.co/campaign-reports/hashtag-scanner"
            >
              click here for help and FAQs
            </TargetLink>
          </p>)}
        </div>
      }

    </DyzioModal>
  );
};

HashtagScannerModal.propTypes = {
  onInputValueChange: PropTypes.func.isRequired,
  onScanHandler: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  scannerResultsCount: PropTypes.string,
  isScanning: PropTypes.bool.isRequired,
  isEmptyState: PropTypes.bool.isRequired,
  hashtags: PropTypes.array.isRequired,
  hashtagsErrors: PropTypes.array.isRequired,
  currentScannedPlatform: PropTypes.oneOf([null, YOUTUBE, FACEBOOK, INSTAGRAM, TWITTER]).isRequired,
};

HashtagScannerModal.defaultProps = {
  scannerResultsCount: null,
};

export default HashtagScannerModal;



/** WEBPACK FOOTER **
 ** ./src/components/hashtag-scanner-modal/index.js
 **/